module.exports = __webpack_public_path__ + "img/download_icon.c51c928c.png";